// extracted by mini-css-extract-plugin
export default {"intro-section":"TeamsHeaderSection_intro-section__s3hcx","button-wrapper":"TeamsHeaderSection_button-wrapper__o3Gpm","intro-text":"TeamsHeaderSection_intro-text__PqBfn"};